import httpClient from '../httpService';
import { TS_ChuyenNganhTotNghiep } from './ChuyenNganhTotNghiepModels';

const ChuyenNhanhTotNghiepApiUrl = '/api/ChuyenNganhTotNghiep';
export const ChuyenNganhTotNghiepService = {
    getAll: async (): Promise<TS_ChuyenNganhTotNghiep[]> => {
        const res = await httpClient.get(`${ChuyenNhanhTotNghiepApiUrl}/SelectAll`);
        return res?.data ?? [];
    },
    getById: async (id: number): Promise<TS_ChuyenNganhTotNghiep> => {
        const res = await httpClient.get(`${ChuyenNhanhTotNghiepApiUrl}/SelectById/${id}`);
        return res.data.data;
    },
    create: async (body: TS_ChuyenNganhTotNghiep): Promise<TS_ChuyenNganhTotNghiep> => {
        const res = await httpClient.post(`${ChuyenNhanhTotNghiepApiUrl}/Insert`, body);
        return res.data.data;
    },
    update: async (id: number, body: TS_ChuyenNganhTotNghiep): Promise<any> => {
        const res = await httpClient.put(`${ChuyenNhanhTotNghiepApiUrl}/Update/${id}`, body);
        return res.data.data;
    },
    delete: async (id: number): Promise<boolean> => {
        const res = await httpClient.delete(`${ChuyenNhanhTotNghiepApiUrl}/Delete/${id}`);
        return res.data.data;
    }
};
